/* eslint-disable react/require-default-props */
import { FC } from "react";
import { DsmModal } from "@dsm-dcs/design-system-react";
import { useIntl } from "../../../../_metronic/i18n/customUseIntl";
import { DsmButtonV2, useButtonStyles } from "./DsmButton";

interface SelectionWarningDialogProps {
  open: boolean;
  confirmHandler: () => void;
  cancelHandler: () => void;
  closeHandler: () => void;
  headerText: string;
  bodyText: string;
  icon: string;
}

const SelectionWarningDialog: FC<SelectionWarningDialogProps> = ({
  open,
  confirmHandler,
  cancelHandler,
  closeHandler,
  headerText,
  bodyText,
  icon,
}) => {
  const intl = useIntl();
  const buttonClasses = useButtonStyles();

  return (
    <div>
      <DsmModal
        open={open}
        icon={icon}
        header={intl.formatMessage({
          id: headerText,
        })}
        onDsmClosed={() => closeHandler()}
      >
        <p slot="content">
          {intl.formatMessage({
            id: bodyText,
          })}
        </p>
        <>
          <DsmButtonV2
            slot="actions"
            onClick={cancelHandler}
            className={buttonClasses.secondaryButton}
          >
            {intl.formatMessage({
              id: "GENERAL.CANCEL",
            })}
          </DsmButtonV2>
          <DsmButtonV2
            variant="secondary"
            slot="actions"
            onClick={confirmHandler}
          >
            {intl.formatMessage({
              id: "GENERAL.CONFIRM",
            })}
          </DsmButtonV2>
        </>
      </DsmModal>
    </div>
  );
};

export default SelectionWarningDialog;
